import { Body, Container } from "./styled";

const Loading = () => {
  return (
    <Container>
      <Body />
    </Container>
  );
};

export default Loading;